import React, { useState } from 'react';
import {
  Box,
} from '@mui/material';

import {
  LoadingCircle,
  SearchBar,
  SearchError,
  Logo
} from '../components';


export default function Search({ auth }) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  return (
    <Box 
      sx={{
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        "justifyContent": "center",
        "marginY": "40px",
        "marginX": { xs: 2, md: 10 },
        "color": theme => theme.palette.text.primary,
        "fontWeight": "bold",
      }}
    >
      <Box sx={{ marginRight: "auto", marginBottom: "40px" }}>
        <Logo />
      </Box>

      <Box sx={{
        "marginTop": "40px",
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        "fontSize": { xs: "32px", md: "56px" },
        "textAlign": "center",
      }}>
        <div>O melhor catálogo de produtos</div>
        <div>para o seu negócio</div>
      </Box>

      <Box
        sx={{
          "display": "flex",
          "flexDirection": "column",
          "alignItems": "center",
          "justifyContent": "space-between",
          "marginTop": "80px",
        }}
      >
        <Box sx={{ marginBottom: "40px" }}>
          <SearchBar
            token={auth.token}
            setLoading={setLoading}
            setError={setError}
          />
        </Box>
        
        {error && !loading? <SearchError message={error} /> : null}

        {loading? <LoadingCircle /> : null}

      </Box>
    </Box>
  );
}